import React from 'react';
import { Navigate } from 'react-router-dom';
import { TokenUserHelper } from './services/token-user-service';
import { CommonConstants } from './constants/common-constants';

interface ProtectedRouteProps {
  userType: string;
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ userType, children }) => {
  const tokenUser = TokenUserHelper.Get();
  
  if (!tokenUser) {
    return <Navigate to="/User/Login" replace />;
  }

  if (userType === CommonConstants.UserType.School && tokenUser.UserType !== CommonConstants.UserType.School) {
    return <Navigate to="/User/Login" replace />;
  }

  if (userType === CommonConstants.UserType.Admin && tokenUser.UserType !== CommonConstants.UserType.Admin) {
    return <Navigate to="/User/Login" replace />;
  }

  return <>{children}</>;
};

interface DualProtectedRouteProps {
  schoolComponent: React.ComponentType;
  facilitatorComponent: React.ComponentType;
}

/**
 * For routes shared between school and admin users (same URL, different component).
 * Renders the appropriate component based on the logged-in user's type.
 */
export const DualProtectedRoute: React.FC<DualProtectedRouteProps> = ({
  schoolComponent: SchoolComp,
  facilitatorComponent: FacilitatorComp,
}) => {
  const tokenUser = TokenUserHelper.Get();

  if (!tokenUser) {
    return <Navigate to="/User/Login" replace />;
  }

  if (tokenUser.UserType === CommonConstants.UserType.School) {
    return <SchoolComp />;
  }

  if (tokenUser.UserType === CommonConstants.UserType.Admin) {
    return <FacilitatorComp />;
  }

  return <Navigate to="/User/Login" replace />;
};